"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var handleResize = function (pointerify) {
    pointerify.setRootGeometry();
};
exports.default = handleResize;
//# sourceMappingURL=handleResize.js.map